import React from 'react';
import {
  CaptionText,
  FlexColumn,
  FlexRow,
  HashLength,
} from '@make-software/cspr-design';
import { AssociatedKeyRelatedToAccount } from '@block-explorer/entities';
import { BodyText } from '@block-explorer/ui';
import styled from 'styled-components';
import Skeleton from 'react-loading-skeleton';
import Big from 'big.js';
import CsprAmount from '../cspr-amount/cspr-amount';
import { PrecisionCase } from '../../utils/currency';
import AccountInfoDataWithBadge from '../account-info-data-with-badge/account-info-data-with-badge';
import { deriveAccountInfo } from '../../utils/account';

export const AssociatedKeyContainer = styled(FlexRow)<{
  isTitle?: boolean;
}>(({ isTitle }) => ({
  width: '100%',
  padding: isTitle ? '8px 0' : '13px 0',
  position: 'relative',
}));

const BalanceContainer = styled(FlexColumn)(({ theme }) => ({
  textAlign: 'right',
}));

interface AssociatedAccountRowProps {
  data: AssociatedKeyRelatedToAccount | null;
  loading?: boolean;
  isTitle?: boolean;
}

export const AssociatedAccountRowWithCsprName = ({
  data,
  loading,
  isTitle = false,
}: Omit<AssociatedAccountRowProps, 'getAccountInfo'>) => {
  const {
    public_key,
    balance,
    cspr_name,
    account_info,
    centralized_account_info,
  } = data;

  if (loading || !data) {
    return <Skeleton height={40} />;
  }

  const accountInfo = deriveAccountInfo(
    account_info || centralized_account_info
  );
  const logo = accountInfo?.logo;
  const name = accountInfo?.name;

  const emptyBalance =
    !loading && balance != null && Big(Number(balance)).lte('0');

  return (
    <AssociatedKeyContainer
      justify={'space-between'}
      align={'center'}
      isTitle={isTitle}
    >
      <AccountInfoDataWithBadge
        loading={loading}
        logo={logo}
        name={name}
        publicKey={public_key}
        hashLength={HashLength.LITTLE}
        csprName={cspr_name}
        isCopyEnabled
      />
      <FlexRow align={'center'}>
        <BalanceContainer>
          {isTitle ? (
            <CaptionText size={2} variation="darkGray">
              Balance
            </CaptionText>
          ) : null}
          <BodyText size={3} monotype>
            {emptyBalance ? (
              <CsprAmount
                motes={'0'}
                precisionCase={PrecisionCase.deployCost}
              />
            ) : (
              <CsprAmount
                motes={balance!.toString()}
                precisionCase={PrecisionCase.deployCost}
              />
            )}
          </BodyText>
        </BalanceContainer>
      </FlexRow>
    </AssociatedKeyContainer>
  );
};

export default AssociatedAccountRowWithCsprName;
